
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IuC4m%2BC4tOC4lCJ9!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IuC4m%2BC4tOC4lCJ9!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IlR1dHVwIn0%3D!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IlR1dHVwIn0%3D!"
        )
      ),
"zh": createLanguage(
        require.resolveWeak("./translations.json-zh-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"),
        () => import(
          /* webpackChunkName: "zh-translations" */
          "./translations.json-zh-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IuC4m%2BC4tOC4lCJ9!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IuC4m%2BC4tOC4lCJ9!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IlR1dHVwIn0%3D!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IlR1dHVwIn0%3D!"
        )
      ),
"zh-HK": createLanguage(
        require.resolveWeak("./translations.json-zh-HK-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"),
        () => import(
          /* webpackChunkName: "zh-HK-translations" */
          "./translations.json-zh-HK-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IkNsb3NlIn0%3D!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IlvDh8aaw7bDtsWh4bq94bq9XSJ9!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../node_modules/.pnpm/virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJDbG9zZSI6IlvDh8aaw7bDtsWh4bq94bq9XSJ9!"
        )
      )
      });
  
      export { translations as default };
    